import type { InventoryItem } from '../types/domain'

export const isItemApplicableToGame = (item: InventoryItem, gameId: string) => {
  return item.applicableGames.length === 0 || item.applicableGames.includes(gameId)
}